import { Injectable } from '@angular/core';
import { Store } from '../../../services/store';
import { Observable, tap } from 'rxjs';
import { ClientOrdersProvider } from './client-orders.provider';
import { toVoid } from '../../../utils/void';
import { ClientOrderRowVm } from './models/client-order-row.view-model';
import { ClientOrderStatus } from './models/client-order-list-item.dto';

export interface ClientOrdersState {
  loading: boolean;
  orders: ClientOrderRowVm[] | undefined;
  search: string;
  statusFilter: ClientOrderStatus | undefined;
}

const INITIAL_STATE: ClientOrdersState = {
  loading: false,
  orders: undefined,
  search: '',
  statusFilter: undefined
};

@Injectable({ providedIn: 'root' })
export class ClientOrdersStore extends Store<ClientOrdersState> {
  constructor(private provider: ClientOrdersProvider) {
    super(INITIAL_STATE);
  }

  init(): Observable<void> {
    this.update(state => ({ ...state, loading: true }));

    return this.load();
  }

  search(term: string): Observable<void> {
    this.update(state => ({ ...state, search: term }));

    return this.load();
  }

  filterByStatus(status: ClientOrderStatus | undefined): Observable<void> {
    this.update(state => ({ ...state, statusFilter: status }));

    return this.load();
  }

  // Search and filter always travel together, so every load (including the
  // initial one) re-queries with both applied — state and request cannot drift
  // (bom-list precedent); the order comes sorted from the backend
  private load(): Observable<void> {
    const { search, statusFilter } = this.state;

    return this.provider.getClientOrders(search || undefined, statusFilter)
      .pipe(
        tap(orders => {
          this.update(state => ({
            ...state,
            loading: false,
            orders: orders.map(ClientOrderRowVm.mapModelToViewModel)
          }));
        }),
        toVoid()
      );
  }
}
